

import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'common/css/master.css';
// import '../css/transport.css'
import Header from 'common/js/header/header';
// import ExamPatternCreatorForm from './examPatternCreatorForm';
import ExamPatternCreatorTbl from './examPatternCreatorTbl';

import { getClassListSvc, getQpPatternListSvc, savePatternSvc, deletePatternSvc } from './examPatternCreatorSvc';
import PatternSlider from './patternSlider';

const STORAGE_KEY = 'examPatternCreator_savedPatterns';

function ExamPatternCreatorCtrl() {
    const [loader, setLoader]               = useState('none');
    const [flgSlider, setFlgSlider]         = useState(false);
    const [randNo, setRandNo]               = useState(0);
    const [savedPatterns, setSavedPatterns] = useState([]);
    const [patternObj, setPatternObj]       = useState({});
    const [lstClass,     setLstClass]     = useState([]);
    const [lstPattern,   setLstPattern]   = useState([]);
    const [clsId,        setClsId]        = useState(0);

    useEffect(() => {
        // setLoader('block');
        getClassListSvc((res) => {
            setLoader('none');
            if (res.status === 'Success') {
                console.log("lstClass from API:", res.lstClass);
                setLstClass(res.lstClass);
            } else {
                toast.error(res.message);
            }
        });
    }, []);

    function onClsChange(e) {
        const selectedClsId = parseInt(e.target.value);
        setClsId(selectedClsId);
        setLstPattern([]);
        if (selectedClsId === 0) return;
        // setLoader('block');
        getQpPatternListSvc(selectedClsId, (res) => {
            setLoader('none');
            if (res.status === 'Success') {
                setLstPattern(res.lstPattern);
            } else {
                toast.error(res.message);
            }
        });
    }
    function generateRandomNo() {
        setRandNo(Math.floor(Math.random() * 999999));
    }

    function openSlider(isNew = false) {
        if (!clsId) {
            toast.error('Please select a class first');
            return;
        }
        if (isNew) setPatternObj({});
        setFlgSlider(true);
    }

    function closeSlider() {
        setFlgSlider(false);
        generateRandomNo();
    }

    function deletePattern(patternId) {
        if (!window.confirm('Are you sure you  want to delete the pattern')) return;
        deletePatternSvc(patternId, (res) => {
            if (res.status === 'Success') {
                toast.success('Pattern deleted successfully');
                setPatternObj({});
                refreshPatternList();
            } else {
                toast.error(res.message);
            }
        });
    }

    function refreshPatternList() {
        if (!clsId) return;
        getQpPatternListSvc(clsId, (res) => {
            if (res.status === 'Success') setLstPattern(res.lstPattern);
        });
    }

    const handleSave = (pPatternId, pPattern, pPatternDesc, onSuccess) => {
        const objPattern = {
            patternId:   pPatternId,
            clsId:       clsId,
            pattern:     pPattern,
            patternDesc: pPatternDesc,
        };
        savePatternSvc(objPattern, (res) => {
            if (res.status === 'Success') {
                toast.success(res.message);
                setPatternObj({ ...objPattern, patternId: res.patternId || pPatternId });
                if (onSuccess) onSuccess(res.patternId);
                refreshPatternList();
            } else {
                toast.error(res.message);
            }
        });
    };

    return (
        <div className='MainContainer'
            style={{ pointerEvents: loader === 'none' ? 'auto' : 'none' }}>
            <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: loader }}>
                <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
            </div>
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <div className="TestTblWrapper">
                <div className="TestTbl">
                    <ExamPatternCreatorTbl
                        key={randNo}
                        lstPattern={lstPattern}
                        openSlider={openSlider}
                        setPatternObj={setPatternObj}
                        lstClass={lstClass}
                        clsId={clsId}
                        onClsChange={onClsChange}
                         deletePattern={deletePattern}
                    />
                </div>
                <div style={{ float: 'left', marginTop: 50 }}>
                    <span
                        title="Add Pattern"
                        className="addIcon glyphicon glyphicon-plus-sign"
                        onClick={() => openSlider(true)}
                    ></span>
                </div>
                <div className="TestSlider" style={{ display: flgSlider ? 'block' : 'none' }}>
                    {flgSlider && (
                        <PatternSlider
                            key={randNo}
                            patternId={patternObj.patternId || 0}
                            pattern={patternObj.pattern || ''}
                            patternDesc={patternObj.patternDesc || ''}
                            clsId={clsId}
                            closeSlider={closeSlider}
                            updateKey={generateRandomNo}
                            onSave={handleSave}
                            refreshPatternList={refreshPatternList}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default ExamPatternCreatorCtrl;




